module.exports = __webpack_public_path__ + "img/cards2_w.68b22f71.svg";